import type { PaymentIqRoles } from 'apps/shared/data-access/types/metadata/metadata.types';
import type { UserDataType } from 'apps/shared/data-access/types/users/backoffice-users.types';
import type { DropdownOption } from 'apps/core/types/global.types';

export type UserRole = PaymentIqRoles | UserFlags;

export type UserRoles = UserRole[];

export enum UserFlags {
  IS_MASTER_MERCHANT = 'IS_MASTER_MERCHANT',
  HAS_MASTER_MERCHANT = 'HAS_MASTER_MERCHANT',
  IS_ANALYTICS_USER = 'IS_ANALYTICS_USER',
  IS_INTERNAL_USER = 'IS_INTERNAL_USER',
  IS_EXPERIMENTAL_USER = 'IS_EXPERIMENTAL_USER',
}

export interface UserItemProps {
  user: UserDataType;
  merchantOptions: DropdownOption[];
  isOperatorAdmin: boolean;
  onChange?: (data: UserDataType) => void;
  isNewUser?: boolean;
  handleAddNewUser?: () => void;
  toggleUserHistory?: (user: UserDataType) => void;
  updateLoggedInUser?: boolean;
  setSubmitHandler?: (handler: (() => void) | undefined) => void;
  setSubmitCancel?: (handler: (() => Promise<void>) | undefined) => void;
}
